var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Form", { attrs: { formVisible: _vm.showForm } }),
      _vm._v(" "),
      _c("DeleteDialog", {
        attrs: {
          title: "Delete",
          text: "Gebäude wirklich löschen?",
          deleteMode: _vm.deleteMode,
          confirmCallback: _vm.deleteConfirmCallback
        }
      }),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("span", [_vm._v("Gebäude")]),
              _vm._v(" "),
              _vm.user_is_admin
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", padding: "3px 0" },
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/new-building")
                        }
                      }
                    },
                    [_vm._v("Hinzufügen")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row"),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.buildings },
                  on: { "row-click": _vm.rowClickHandler }
                },
                [
                  _vm._l(_vm.tableColumns, function(col, index) {
                    return _c("el-table-column", {
                      key: index,
                      attrs: {
                        label: col.label,
                        prop: col.prop,
                        align: "center",
                        formatter: col.formatter,
                        width: _vm.getColumnWidth(col)
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: { label: "Modul Informationen", align: "center" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Frei", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-col",
                                  { attrs: { align: "center" } },
                                  [
                                    _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.total_available_panels
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Total", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-col",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("el-tag", [
                                      _vm._v(_vm._s(scope.row.total_panels))
                                    ])
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "URL", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-col",
                              { attrs: { align: "center" } },
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      underline: false,
                                      type: "primary",
                                      target: "_blank",
                                      href: _vm.getBuildingUrl(scope.row)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.sanitizeString(scope.row.address)
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "center", fixed: "right", width: "120px" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleView(scope.row.id)
                                  }
                                }
                              },
                              [_vm._v("Ansicht")]
                            ),
                            _vm._v(" "),
                            _vm.user_is_admin
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteClickHandler(
                                          scope.row.id
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Löschen")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Warning",
            visible: _vm.deleteDialogVisible,
            width: "30%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.deleteDialogVisible = $event
            }
          }
        },
        [
          _c("span", [
            _vm._v(
              "It should be noted that the content will not be aligned in center by default"
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.deleteDialogVisible = false
                    }
                  }
                },
                [_vm._v("Abbrechen")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.deleteDialogVisible = false
                    }
                  }
                },
                [_vm._v("Bestätigen")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c0c81a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c0c81a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/buildings/Buildings.vue
// module id = null
// module chunks = 